export default "__VITE_ASSET__DJbuQC4h__"